// extracted by mini-css-extract-plugin
export default {"content":"emptyIndicator_content__hoexC","label":"emptyIndicator_label__tVk+n"};